/**
 * 客服
 */
const App = () => import('@/module/index/layout/App.vue')
const incompleteAcceptance = () => import('@/module/index/pages/customerService/incompleteAcceptance.vue')
const myAcceptance = () => import('@/module/index/pages/customerService/myAcceptance.vue')
const otherAcceptance = () => import('@/module/index/pages/customerService/otherAcceptance.vue')
const otherAcceptanceDetail = () => import('@/module/index/pages/customerService/otherAcceptanceDetail.vue')

export default {
  path: '/customerService',
  component: App,
  redirect: '/customerService/incompleteAcceptance',

  children: [{
    path: '/customerService/incompleteAcceptance',
    component: incompleteAcceptance
  },
  {
    path: '/customerService/myAcceptance',
    component: myAcceptance
  },
  {
    path: '/customerService/otherAcceptance',
    component: otherAcceptance
  },
  {
    path: '/customerService/otherAcceptance/:id',
    component: otherAcceptanceDetail
  }
  ]
}



// WEBPACK FOOTER //
// ./src/publicResource/router/customerService.js